<script type="text/ecmascript-6">
import TileQuestion from "./mixin/TileQuestion.vue";

export default {
    mixins: [
        TileQuestion,
    ],
    props: {
        title: {
            default() {
                return 'Select Door Style';
            }
        },
        component_id: {
            default() {
                return 'slab';
            }
        },
        securedByDesign: {
            required: true,
        },
        doorCore: {
            required: false,
            default: '',
        },
        doorRange: {
            required: false,
            default: '',
        },
        category: {
            required: false,
            default: 0,
        },
    },
    computed: {
        thumbURL() {
            return '/thumb/slab/';
        },
        url() {
            return '/api/options/' + this.fabricator + '/slab?secured_by_design=' + this.securedByDesign + '&door_core=' + this.doorCore + '&door_range=' + this.doorRange + '&category=' + this.category;
        },
        cache_key() {
            return '_' + this.securedByDesign + '_' + this.doorCore + '_' + this.doorRange + '_' + this.category;
        },
        passed_filter() {
            var sbd_ready = this.variable_ready(this.securedByDesign);
            var core_ready = this.doorCore !== '' ? this.variable_ready(this.doorCore) : true;
            var range_ready = this.doorRange !== '' ? this.variable_ready(this.doorRange) : true;

            return sbd_ready && core_ready && range_ready;
        },
    },
    watch: {
        'cache_key': function (val, oldVal) {
            this.update_options();
        },
    }
}
</script>
